import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { fromEvent, Observable, empty } from 'rxjs';
import { auditTime, map, share } from 'rxjs/operators';

@Injectable()
export class WindowResizeService {
    public scroll$: Observable<number>;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        if (isPlatformBrowser(this.platformId)) {
            this.scroll$ = fromEvent(window, 'resize').pipe(auditTime(500)).pipe(
                map(event => {
                    return event.target['innerWidth'];
                }),
                share());
        } else {
            this.scroll$ = empty();
        }
    }

    getCurrentScreenSize() {
        return isPlatformBrowser(this.platformId) ? window.innerWidth : null;
    }
}
